import { render, staticRenderFns } from "./CrudItem.vue?vue&type=template&id=75264dde&scoped=true&"
import script from "./CrudItem.vue?vue&type=script&lang=js&"
export * from "./CrudItem.vue?vue&type=script&lang=js&"
import style0 from "./CrudItem.vue?vue&type=style&index=0&id=75264dde&prod&scoped=true&lang=css&"
import style1 from "./CrudItem.vue?vue&type=style&index=1&id=75264dde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75264dde",
  null
  
)

export default component.exports